import React from 'react';
import { Link } from 'react-router-dom';
import './LandingNav.css';

export default function LandingNav() {
  return (
    <nav className="landing-nav" aria-label="Site navigation">
      <a href="#main" className="landing-nav__skip">Skip to content</a>
      <div className="landing-nav__mark">
        <span className="landing-nav__glyph" aria-hidden="true">◆</span>
        <span className="landing-nav__name">MySecureRoom</span>
      </div>
      <Link to="/auth" className="landing-nav__signin">Sign in</Link>
    </nav>
  );
}
